export default __webpack_public_path__ + "static/media/Hood of Jagged Barbs.4628f4cc.jpg";